import React from "react";
import standeeImg from "../../Assets/image/Digital-Standee-A-Shape-43-Inch.png";

const DigitalStandeeA43 = () => {
  return (
    <div className="w-full bg-white py-16">
      <div className="max-w-7xl mx-auto px-6">

        {/* ================= HERO SECTION ================= */}
        <div className="grid md:grid-cols-2 gap-12 items-center">

          {/* Product Image */}
          <div>
            <img
              src={standeeImg}
              alt="Digital Standee A-Shape 43 Inch"
              className="w-full rounded-2xl shadow-xl"
            />
          </div>

          {/* Product Intro */}
          <div>
            <h1 className="text-4xl  text-blue-700 font-bold mb-4">
              Digital Standee A-Shape – 43 Inch
            </h1>

            <p className="text-gray-600 mb-6 leading-relaxed">
              Beneicon  Digital Standee A-Shape 43 Inch provides bright, 
              sharp, and stable indoor visuals — perfect for promotions, 
              offices, and showrooms.
            </p>

                      <a
  href="https://wa.me/+917065993135"
  target="_blank"
  rel="noopener noreferrer"
  className="bg-blue-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition shadow-lg inline-block"
>
  Know More
</a>

            <div className="mt-6 text-sm text-gray-500">
              <p>
                <span className="font-semibold text-black">Categories:</span> Digital Standee, Trending
              </p>
              <p>
                <span className="font-semibold text-black">Tags:</span> Maximum Visibility, Stable Design
              </p>
            </div>
          </div>
        </div>

        {/* ================= DESCRIPTION ================= */}
        <div className="mt-20">
          <h2 className="text-3xl  text-blue-700 font-bold mb-6">
            High-Impact Indoor Display for Promotions and Presentations
          </h2>

          <p className="text-gray-700 leading-relaxed mb-6">
            Beneicon 43 Inch A-Shape Digital Standee, manufactured by Beneicon Pixel LLP, is a premium
indoor digital display designed for clear visuals and dynamic content presentation. Its stylish
A-shape floor-standing design offers a modern appearance, stable structure, space-saving
installation, and strong visibility in indoor environments. Built using premium-grade display and
professional control systems, each unit is precision-engineered and performance-tested to ensure
stable operation and long service life in indoor conditions.
          </p>

          <p className="text-gray-700 leading-relaxed">
            Its A-shape design ensures stability and visibility from multiple angles, 
            while the 43-inch screen delivers bright, clear, and vibrant visuals 
            for maximum engagement.
          </p>
        </div>

        {/* ================= KEY FEATURES ================= */}
        <div className="mt-20">
          <h2 className="text-3xl text-blue-700 font-bold mb-8">Key Features</h2>

          <ul className="space-y-4 text-gray-700">
            <li>• 43-Inch Full HD Screen – Sharp 1920×1080 resolution</li>
            <li>• A-Shape Freestanding Design – Stable and stylish structure</li>
            <li>• Portable & Lightweight – Easy repositioning indoors</li>
            <li>• User-Friendly Interface – Supports videos, images & promotions</li>
            <li>• Energy Efficient – Bright visuals with optimized power use</li>
          </ul>
        </div>

        {/* ================= TECHNICAL SPECIFICATIONS ================= */}
        <div className="mt-20 bg-gray-50 p-10 rounded-2xl">
          <h2 className="text-3xl  text-blue-700 font-bold mb-8">Technical Specifications</h2>

          <div className="grid md:grid-cols-2 gap-8 text-gray-700">
            <div>
              <p><span className="font-semibold">Brand:</span> Beneicon</p>
<p><span className="font-semibold">Product:</span> Digital Standee (Signage)</p>
<p><span className="font-semibold">Model No:</span> B43DS1-A</p>
<p><span className="font-semibold">Screen Size:</span> 43 Inch</p>
<p><span className="font-semibold">Resolution:</span> Full HD / 1920×1080</p>
<p><span className="font-semibold">Brightness:</span> 300 – 500 nits</p>
<p><span className="font-semibold">Viewing Angle:</span> 178° (H) / 178° (V)</p>
<p><span className="font-semibold">Content Size:</span> 1080 × 1920</p>
<p><span className="font-semibold">RAM:</span> 1.5GB</p>
<p><span className="font-semibold">Storage:</span> 8GB</p>
<p><span className="font-semibold">Connectivity:</span> USB / LAN / HDMI</p>
<p><span className="font-semibold">Audio:</span> Built-in Speakers</p>
<p><span className="font-semibold">Body Material:</span> Metal Frame with Tempered Glass</p>
<p><span className="font-semibold">Type:</span> Floor Standing Usage</p>
<p><span className="font-semibold">Operation:</span> Plug & Play / CMS (Optional)</p>
            </div>

            <div>
              <p><span className="font-semibold">Viewing Angle:</span> 160° (H) / 140° (V)</p>
              <p><span className="font-semibold">Operating Temperature:</span> 0°C to +40°C</p>
            </div>
          </div>
        </div>

        {/* ================= APPLICATIONS ================= */}
        <div className="mt-20">
          <h2 className="text-3xl text-blue-700 font-bold mb-8">Applications</h2>

          <p className="text-gray-700 leading-relaxed">
            Retail Stores • Offices • Exhibitions • Showrooms • Indoor Promotions
          </p>
        </div>

        {/* ================= TAGLINE ================= */}
        <div className="mt-20 text-center">
          <p className="text-lg font-semibold text-gray-800">
            Deliver vivid indoor visuals with stability and style — 
            Beneicon  Digital Standee A-Shape 43 Inch.
          </p>
        </div>

        {/* ================= REVIEWS ================= */}
        <div className="mt-20 border-t pt-10">
          <h2 className="text-2xl  text-blue-700 font-bold mb-4">Reviews (0)</h2>
          <p className="text-gray-500">
            There are no reviews yet.
          </p>
        </div>

      </div>
    </div>
  );
};

export default DigitalStandeeA43;